<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputTaxId" });
import { InputText } from "../../../../inputs/index.js";
import { TAX_ID } from "./config/tax-id.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
export let countryCode = "";
$: hint = TAX_ID[countryCode] || "";
</script>

<InputText
    bind:value
    placeholder = 'resource.organization.properties.tax_id.placeholder'
    label = 'resource.organization.properties.tax_id.label'
    name = 'organization.tax_id'
    { hint }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>